module.exports = __webpack_public_path__ + "img/logo_liveLearning.c75bb4b1.png";